import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import './scss/style.scss'
import router from './router'
import "./vee-validate";
import axios from "axios"
import store from "./store/index";
import VTooltip from "v-tooltip";
import VueGtag from "vue-gtag";
import './plugins'
import { config } from './config'

import VueMeta from 'vue-meta'
import VueCookies from 'vue-cookies'

import vSelect from 'vue-select'
import Toast from "vue-toastification"
import "./scss/materialdesignicons.scss"
import "vue-toastification/dist/index.css"

const options = {
    position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
};

Vue.component('v-select', vSelect)
Vue.use(Toast, options)

if (process.env.VUE_APP_API_URL == 'https://api.pickafund.com') {
    Vue.use(VueGtag, {
        config: { id: config.idAnalytics },  
    }, router);
}


Vue.use(VueMeta)
Vue.use(VueCookies);


axios.defaults.withCredentials = true
axios.defaults.baseURL = config.API_URL;
import VueSimpleMarkdown from 'vue-simple-markdown'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
Vue.use(VueSimpleMarkdown)


Vue.config.productionTip = false
Vue.use(Buefy)

let VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.use(VTooltip);
Vue.config.productionTip = false;

Vue.config.warnHandler = function (msg) {
    // `trace` is the component hierarchy trace
    if (msg.includes("native modifier for v-on is only valid on components")) {
        msg = null;
    }
}


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')



axios.get("/api/is-logged-in")
    .then(response => {
        if (response.data.loggedin && response.data.loggedin === true) {
            store.commit("auth/SET_AUTHENTICATED", true)
            localStorage.removeItem('comparecount');
            localStorage.removeItem('comparecount2');
            axios.get("/api/profile").then(response => {
                const profile = response.data
                store.commit("auth/SET_EMAIL", profile.email)
                store.commit("auth/SET_USER_PROFILE", profile);
                if (profile.completedstage2 === true) {
                    store.commit("auth/SET_PROFILE", 2)
                }
                else if (profile.completedstage1 === true) {
                    store.commit("auth/SET_PROFILE", 1)
                }
                if(!profile.age) router.push('/account')
            })
        }
        else {
            store.commit("auth/SET_AUTHENTICATED", false)
        }
    })
    .catch(() => {
    })
